import {AfterViewInit, Component, Input, OnDestroy} from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-image-container',
  templateUrl: './image-container.component.html',
  styleUrls: ['./image-container.component.css']
})
export class ImageContainerComponent implements AfterViewInit, OnDestroy {

  @Input() images: any[];
  @Input() defaultImage: any;
  @Input() product: any;
  activeImg: number = 0;
  private isMobile: boolean = false;

  ngAfterViewInit(): void {
    this.isMobile = window.matchMedia("(hover: none)").matches;
    if (!this.isMobile) {
      $('.xzoom, .xzoom-gallery').xzoom({
        tint: '#333',
        Xoffset: 15,
        lensHeight: 100,
        lensWidth: 100,
      });
    }
  }

  ngOnDestroy() {
    $.fancybox.close();
  }


  changeActiveImage(index: number): void {
    this.activeImg = index;
  }

  openFancyBox(image: any, event: any) {
    const images = this.images.map((img) => ({ src: img.url, href: img.url }));
    if (this.isMobile) {
      $.fancybox.open(images, {
        buttons: ['zoom', 'slideShow', 'thumbs', 'close'],
        padding: 0,
        helpers: {
          overlay: {
            locked: false
          }
        }
      });
    } else {
      var xzoom = $(image).data('xzoom');
      xzoom.closezoom();
      $.fancybox.open(images, {
        buttons: ['zoom', 'slideShow', 'thumbs', 'close'],
        padding: 0,
        helpers: {
          overlay: {
            locked: false
          }
        }
      });
    }

    event.preventDefault();
  }
}
